import e from"styled-components";const t=e.div`
	display: flex;
	flex-flow: row;
	justify-content: space-between;
	align-items: center;
	column-gap: 8px;
`,i=e.div`
	display: flex;
	flex-flow: row;
	gap: 12px;
`,l=e.img`
	width: ${({isTemplate:e})=>e?"16px":"22px"};
	height: ${({isTemplate:e})=>e?"16px":"22px"};
	border-radius: 3px;
	object-fit: cover;
`,o=e.div`
	color: ${({color:e})=>e};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"11px":"18px"};
	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"11.333px":"21px"};
`,p=e.div`
	display: flex;
	align-items: baseline;
	gap: 0px 6px;
	align-self: stretch;
	align-items: center;
	flex-wrap: wrap;
	color: ${({theme:e})=>e.text.text};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"8px":"13px"};
	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"8px":"19px"};
`,a=e.a`
	color: ${({theme:e})=>e.text.gray};
	font-family: 'SF Pro Display';
	text-decoration: none;
	font-size: ${({isTemplate:e})=>e?"8px":"13px"};
	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"8px":"19px"};
`;export{a as Author,p as CreatedByWrapper,t as ListContent,i as SpaceAndTitleWrapper,l as SpaceAvatar,o as Title};
